// extracted by mini-css-extract-plugin
export default {"textload":"Skeleton__textload--jqnh6","shine":"Skeleton__shine--c7uyt","skeletonimg":"Skeleton__skeletonimg--zxeXk Skeleton__textload--jqnh6"};